



























import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { DateTextLayer } from "@/model/document2/page/surface/design/layer/dateTextLayer";
import { PlainTextLayer } from "@/model/document2/page/surface/design/layer/plainTextLayer";
import { MathHelper } from '@/helper/mathHelper';

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class TextOutlineController extends Vue 
{
    @Prop() layer! : DateTextLayer;

    private getTextInfo(name : string)
    {
        return this.layer.textInfo[name];
    }

    private get outlineThickness()
    {
        var value = this.getTextInfo("outlineThickness");
        return value != null ? value : 50;
    }

    private set outlineThickness(outlineThickness)
    {
        this.changeTextInfo("isOutline", Number(outlineThickness) > 0, false, false);
        this.changeTextInfo("outlineThickness", Number(outlineThickness), false, false);
    }

    private get outlineThicknessText()
    {
        return this.outlineThickness.toFixed() + "%";
    }

    private onOutlineThicknessChanged()
    {
        this.changeTextInfo("outlineThickness", this.outlineThickness, true, false);
    }

    private get outlineIntensity()
    {
        var value = this.getTextInfo("outlineIntensity");
        return value != null ? value : 50;
    }

    private set outlineIntensity(outlineIntensity : number)
    {
        this.changeTextInfo("isOutline", Number(outlineIntensity) > 0, false, false);
        this.changeTextInfo("outlineIntensity", Number(outlineIntensity), false, false);
    }

    private get outlineIntensityText()
    {
        return this.outlineIntensity.toFixed() + "%";
    }

    private onOutlineIntensityChanged()
    {
        this.changeTextInfo("outlineIntensity", this.outlineIntensity, true, false);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }

    private changeTextInfo(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeTextInfo", propertyName, value, isFinish, isOnce);
    }
}
